<span #scrollMarker class="page-header-scroll-marker" aria-hidden="true"></span>
<header
  #header
  class="container-header"
  [class.container-header--shadow]="shadow()"
  [class.container-header--condensed]="condensed()"
  [class.container-header--static-on-phone]="!stickyOnPhone()">
  <div #titleBlock class="dashboard-top-bar">
    <h1 class="container-header-title" [appTopMenuTitle]="topMenuTitle()">{{ title() }}</h1>
    @if (description()) {
      <p class="dashboard-top-bar-description">{{ description() }}</p>
    }
  </div>
  <div #filters class="dashboard-top-bar-left">
    <ng-content></ng-content>
  </div>
  <div #actions class="page-header-actions">
    <ng-content select="[pageHeaderActions]"></ng-content>
  </div>
</header>
